export default __webpack_public_path__ + "static/solder-60c1646acb56df7da42a9c0cac919d5c.png";